<template>
  <div class="col-12 view">
    <card class="card-contributions">
      <i class="fa fa-calendar-check mt-5" style="font-size: 1.3em; color: var(--color-primary)"></i>
      <h6 style="display: inline" class="pl-3">{{ $t("message.Appointment Details") }}</h6>

      <div class="row" v-if="appointment">
        <div class="col-12 mt-4">
          {{ $t("message.Scheduled at") }}
          {{ getFormattedDate(appointment.scheduledTimestamp.start) }}
        </div>
      </div>

      <div class="row" slot="footer">
        <div class="col-12">
          <div class="row">
            <div class="col-12">
              <i class="fa fa-user-md" style="font-size: 1.3em; color: var(--color-primary)"></i>
              <h6 style="display: inline" class="pl-3">
                {{ $t("message.Doctor Details") }}
              </h6>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12" v-if="appointment">
              {{ $t("message.Dr") }} .
              {{ appointment.provider.firstName }}
              {{ appointment.provider.lastName }}
            </div>
            <div class="col-12" v-if="appointment.provider.specialityText">
              {{ appointment.provider.specialityText }}
            </div>
            <div class="col-12 mt-1" v-if="appointment.provider.description">
              {{ appointment.provider.description }}
            </div>
          </div>
          <div class="row mt-4" v-if="selectedLocation && selectedLocation.name">
            <div class="col-12">
              <i class="fas fa-hospital" style="font-size: 1.3em; color: var(--color-primary)"></i>
              <h6 style="display: inline" class="pl-3">{{selectedLocation.name}}<span style="padding-left: 0px;" v-if="selectedLocation.addressDetails && selectedLocation.addressDetails.address">{{' - ' + selectedLocation.addressDetails.address}}</span></h6>
            </div>
          </div>
        </div>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  computed: {
    appointment() {
      return this.$store.state.appointment;
    },
    selectedLocation() {
      return this.$store.state.selectedLocation;
    },
  },
  methods: {
    getFormattedDate(date) {
      return moment(parseInt(date)).format("MMMM Do YYYY, hh:mm a");
    },
  },
  async mounted() {
    await this.$store.commit("setState", {
      stateName: "selectedLocation",
      stateValue: null,
    });
    console.log(this.appointment);
    if (this.appointment && this.appointment.endpoint) {
      try {
        let endpoint = await this.$store.dispatch(
          "getEndpoint",
          this.appointment.endpoint
        );
        if (endpoint && endpoint.location && endpoint.location.name) {
          this.$store.commit("setState", {
            stateName: "selectedLocation",
            stateValue: endpoint.location,
          });
        }
      } catch (e) {
        console.log(e);
      }
    }
  },
};
</script>
